import React from 'react';
import i18next from 'i18next';
import { splitByUppercase } from 'infrastructure/functions/split-by-uppercase';

import s from './styles.module.scss';

interface IProps {
  value: string;
}

const nameMapper: Record<string, string> = {
  CCMPatientMedicalRecords: i18next.t('labels.patientMedicalRecords'),
  PatientsICDCodes: i18next.t('labels.conditions'),
};

const SectionCol: React.FC<IProps> = ({ value }) => {
  return (
    <span className={s.date}>
      {nameMapper[value] ?? splitByUppercase(value).join(' ')}
    </span>
  );
};

export default SectionCol;
